import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_CUSTOM_FIELDS',
    icon: 'GridIcon',
    action: constants.action.permissionViewCustomVar,
    resource: constants.resource.customVariables,
    route: 'custom-fields',
  },
]
